export default {
  bizOrderNo: 'Biz Order No.',
  productOrderNo: 'Product Order No.',
  mawbNo: 'MAWB No.',
  hawbNo: 'HAWB No.',
  hawbSelection: 'HAWB Option',
  hasHawb: 'With HAWB',
  noHawb: 'No HAWB',
  agreementOrderNo: 'Agreement Order No.',
  customer: 'Customer',
  customerName: 'Customer Name',
  departAirport: 'Departure Airport',
  arriveAirport: 'Arrival Airport',
  flightDate: 'Flight Date',
  flightNo: 'Flight No.',
  grossWeight: 'Gross Weight',
  chargeWeight: 'Chargeable Weight',
  volume: 'Volume',
  pieceCount: 'Pieces',
  cargoType: 'Cargo Type',
  productType: 'Product Type',
  customerSource: 'Customer Source',
  transportMode: 'Transport Mode',
  region: 'Region',
  destination: 'Destination Area',
  currency: 'Currency',
  issuingAirline: 'Issuing Airline',
  palletType: 'Pallet Type',
  legalEntityRelation: 'Legal Entity Relation',
  realName: 'Name',
  username: 'Username',
  email: 'Email',
  phone: 'Phone',
  oldPassword: 'Old Password',
  newPassword: 'New Password',
  confirmPassword: 'Confirm Password',
  role: 'Role',
  profitAmount: 'Profit Amount',
  percentage: 'Percentage',
  profitDetail: 'Profit Allocation',
  // BizOrderDetailDialog fields
  clientRefNo: 'Client Ref. No.',
  contractType: 'Contract Type',
  customerCode: 'Customer Code',
  customerLevel: 'Customer Level',
  paymentTerms: 'Payment Terms',
  salesOwner: 'Sales Owner',
  contactName: 'Contact',
  contactPhone: 'Contact Phone',
  contactAddress: 'Contact Address',
  customsType: 'Customs Type',
  creatorName: 'CS Staff',
  customerRemark: 'Customer Remark',
  departure: 'Departure',
  destinationPort: 'Destination',
  hawbPrealertDeclared: 'HAWB Prealert',
  taxFlag: 'Taxable/Duty Free',
  shippingTerms: 'Shipping Terms',
  serviceItems: 'Service Items',
  paymentMethod: 'Payment Method',
  orderCategory: 'Order Category',
  shipperName: 'Shipper Name',
  shipperAddress: 'Shipper Address',
  shipperRegion: 'Shipper Region',
  shipperPhone: 'Shipper Phone',
  shipperContact: 'Shipper Contact',
  shipperCity: 'Shipper City',
  consigneeName: 'Consignee Name',
  consigneeAddress: 'Consignee Address',
  consigneeRegion: 'Consignee Region',
  consigneePhone: 'Consignee Phone',
  consigneeContact: 'Consignee Contact',
  consigneeCity: 'Consignee City',
  masterShipperInfo: 'Shipper Information',
  masterConsigneeInfo: 'Consignee Information',
  bookingMethod: 'Booking Method',
  transitPort: 'Transit Port',
  destinationRegion: 'Destination Region',
  finalDestination: 'Delivery Address',
  requiredDeliveryDate: 'RDL',
  totalWeight: 'Total Weight (KG)',
  totalVolume: 'Total Volume (CBM)',
  cargoDescription: 'Cargo Description',
  temperatureReq: 'Temperature Req.',
  stackable: 'Stackable',
  stackDirection: 'Stack Direction',
  suggestedUldType: 'Suggested ULD',
  specialRemark: 'Special Remark',
  actualPieces: 'Actual Pieces',
  actualWeight: 'Actual Weight (KG)',
  actualVolume: 'Actual Volume (CBM)',
  actualChargeableWeight: 'Actual Chargeable Wt (KG)',
  warehouseReceiptNo: 'W/H Receipt No.',
  warehouseDataStatus: 'W/H Data Status',
  route: 'Route',
  airline: 'Airline',
  sellCurrency: 'Sell Currency',
  sellRate: 'Sell Rate',
  freightSubtotal: 'Freight Subtotal',
  documentFee: 'Document Fee',
  infoTransmissionFee: 'Info Transmission Fee',
  manifestFee: 'Manifest Fee',
  otherSurcharge: 'Other Surcharge',
  totalReceivable: 'Total Receivable',
  bubbleShareRatio: 'Bubble Share Ratio',
  bubbleDiscountAmount: 'Bubble Discount',
  effectiveReceivable: 'Effective Receivable',
  bubbleInfo: 'Bubble Info',
  salesBaseCost: 'Sales Base Cost',
  salesBaseRate: 'Sales Base Rate',
  salesBaseWeight: 'Sales Base Weight',
  trunkCost: 'Trunk Cost',
  trunkAllocatedRate: 'Allocated Trunk Rate',
  allocatedTrunkCost: 'Allocated Trunk Cost',
  payableTotal: 'Payable Total',
  salesGrossProfit: 'Sales Gross Profit',
  productGrossProfit: 'Product Gross Profit',
  lineProfit: 'Line Profit',
  lineProfitShare: 'Line Profit Share (BJ)',
  salesProfitShare: 'Sales Profit Share (BK)',
  firstTierProfitShare: 'First-tier Agent Share (BL)',
  internalProfitShare: 'Internal Share (BM)',
  feeCategory: 'Fee Category',
  feeDescription: 'Fee Description',
  chargeBasis: 'Charge Basis',
  unitPrice: 'Unit Price',
  quantity: 'Qty',
  subtotal: 'Subtotal',
  discount: 'Discount',
  netAmount: 'Net Amount',
  paymentStatus: 'Payment Status',
  vendorName: 'Vendor',
  feeType: 'Fee Type',
  amount: 'Amount',
  payStatus: 'Pay Status',
  // businessOrders/Index.vue fields
  sellWeight: 'Sell Weight',
  packageType: 'Package Type',
  pieceDimensions: 'Piece Dimensions',
  length: 'L (cm)',
  width: 'W (cm)',
  height: 'H (cm)',
  volumeCbm: 'Volume (CBM)',
  flight: 'Flight',
  chargeableWeight: 'Chargeable Weight',
  salesBaseCurrency: 'Sales Base Currency',
  trunkRate: 'Trunk Rate',
  trunkWeight: 'Trunk Weight',
  trunkCostSurcharge: 'Trunk Surcharge',
  trunkTotalCost: 'Trunk Total Cost',
  costCurrency: 'Cost Currency',
  weight: 'Weight',
  executeTime: 'Execute Time',
  scenarioNumber: 'Profit-share Scenario',
  // businessOrders/Detail.vue fields
  customerSegment: 'Customer Segment',
  salesBase: 'Sales Base',
  // productOrderRecord/Index.vue fields
  timeRange: 'Time Range',
  pallet: 'Pallet',
  totalCargo: 'Total Cargo',
  hawbCount: 'HAWB Count',
  revenue: 'Revenue',
  cost: 'Cost',
  grossProfit: 'Gross Profit',
  agreedPalletWeight: 'Agreed Pallet Weight',
  usedWeight: 'Used Weight',
  palletUsage: 'Pallet Usage',
  salesBaseTotalCost: 'Sales Base Total Cost',
  trunkCurrency: 'Trunk Currency',
  marginRate: 'Margin Rate',
  atdTime: 'ATD Time',
  ataTime: 'ATA Time',
  routeArchive: 'Route Archive',
  incomeSalesBase: 'Income (Sales Base)',
  costTrunk: 'Cost (Trunk)',
  // users/Index.vue fields
  organization: 'Organization',
  password: 'Password',
  // dictionary/Index.vue fields
  dictionaryCode: 'Dictionary Code',
  dictionaryName: 'Dictionary Name',
  dictionaryNameEn: 'English Name',
  dictionaryDescription: 'Description',
  dictionaryDescriptionEn: 'English Description',
  dictionaryCategory: 'Dictionary Categories',
  dictionaryItemDetail: 'Dictionary Item Detail',
  itemCode: 'Item Code',
  itemName: 'Item Name',
  itemNameEn: 'English Name',
  sortOrder: 'Sort Order',
  enabledStatus: 'Status',
  // agreement fields
  agreementNo: 'Agreement No.',
  agreementEntrustNo: 'Agreement Entrust No.',
  agreementPeriod: 'Agreement Period',
  agreementType: 'Agreement Type',
  agreementQuota: 'Agreement Quota',
  agreementUnitPrice: 'Agreement Unit Price',
  agreedPalletCount: 'Agreed Pallet Count',
  occupiedQuota: 'Occupied Quota',
  remainingQuota: 'Remaining Quota',
  origin: 'Origin',
  palletStructure: 'Pallet Structure',
  palletStructureTotal: 'Pallet Structure (Total)',
  palletDetail: 'Pallet Detail',
  palletInfo: 'Pallet Info',
  uldType: 'ULD Type',
  uldCount: 'ULD Count',
  chargeableWeightPerUld: 'Chargeable Weight per ULD',
  chargeableWeightTotal: 'Chargeable Weight Total',
  cycleTotalWeight: 'Cycle Total Weight (KG)',
  remainingWeight: 'Remaining Weight',
  reservedWeight: 'Reserved',
  cycle: 'Cycle',
  period: 'Period',
  subOrderNo: 'Sub Order No.',
  executionMethod: 'Execution Method',
  volumeWeight: 'Volume Weight Quota',
  usageStatus: 'Usage',
  batchGenerationCycle: 'Batch Generation Cycle:',
  productDate: 'Product Date',
  allocationTimes: 'Weight Shares',
  allocatedPalletCount: 'Allocated Pallets',
  allocatedWeight: 'Allocated Weight',
  // system fields
  roleCode: 'Role Code',
  roleName: 'Role Name',
  roleNameEn: 'English Role Name',
  dataScope: 'Data Scope',
  permissionCode: 'Permission Code',
  permissionName: 'Permission Name',
  permissionNameEn: 'English Permission Name',
  permissionType: 'Permission Type',
  parentPermission: 'Parent Permission',
  routePath: 'Route Path',
  componentPath: 'Component Path',
  icon: 'Icon',
  orgCode: 'Org Code',
  orgName: 'Org Name',
  orgNameEn: 'English Org Name',
  orgType: 'Org Type',
  parentOrg: 'Parent Org',
  loginTime: 'Login Time',
  ipAddress: 'IP Address',
  browser: 'Browser',
  os: 'OS',
  failReason: 'Fail Reason',
  configItem: 'Config Item',
  configKey: 'Config Key',
  configDescriptionEn: 'English Description',
  currentPrefix: 'Current Prefix',
  numberExample: 'Example',
  currentValue: 'Current Value',
  lockedAt: 'Locked At',
  remainingLockTime: 'Remaining Lock Time',
  isLocked: 'Locked',
  failCount: 'Fail Count',
  captchaRequired: 'Captcha Required',
  // cs-workbench fields
  isActualWeight: 'Actual Weight',
  pieceTotal: 'Total Pieces',
  volumeTotal: 'Total Volume',
  chargeWeightKg: 'Charge Weight (KG)',
  chargeWeightShort: 'Charge Wt',
  actualWeightShort: 'Actual Weight',
  actualVolumeShort: 'Actual Volume',
  actualChargeWeightShort: 'Actual Charge Wt',
  bubbleChargeableWeight: 'Bubble Charge Wt',
  relatedProductOrderNo: 'Related Product Order No.',
  relatedMawbNo: 'Related MAWB No.',
  relatedHawbNo: 'Related HAWB No.',
  routeEtd: 'Route ETD',
  routeStaff: 'Route Staff',
  grossWeightGw: 'Gross Weight (G.W)',
  volumeShort: 'Volume',
  originalRate: 'Original Rate',
  standardChargeableRatio: 'Standard Chargeable Wt (1:166.667)',
  originalFreightSubtotal: 'Original Freight Subtotal',
  otherSurchargeTotal: 'Other Surcharge Total',
  originalTotalReceivable: 'Original Total Receivable',
  baseChargeableRatio: 'Base Chargeable Wt (1:{ratio})',
  bubblePartWeight: 'Bubble-eligible Part',
  customerReturnWeight: 'Customer Return',
  finalChargeable: 'Final Chargeable Wt',
  bubbleEffectiveRate: 'Effective Rate (after bubble)',
  bubbleFreightSubtotal: 'Bubble Freight Subtotal',
  bubbleEffectiveReceivable: 'Bubble Effective Receivable',
  discountAmount: 'Discount Amount',
  // entry/dialogs fields
  matchStatus: 'Match Status',
  urgency: 'Urgency',
  etd: 'ETD',
  bookedPieces: 'Booked Pieces',
  bookedWeight: 'Booked Weight',
  bookedVolume: 'Booked Volume',
  bookedChargeableWeight: 'Booked Chargeable Weight',
  issueDate: 'Issue Date',
  placeOfIssue: 'Place of Issue',
  deliveryTerms: 'Delivery Terms',
  freightPaymentMethod: 'Freight Payment Method',
  volumetricWeight: 'Volumetric Weight',
  bubbleWeight: 'Bubble Weight',
  detailedDescription: 'Cargo Description',
  marksNumbers: 'Marks & Numbers',
  address: 'Address',
  contactInfo: 'Contact Info',
  allowedVolume: 'Allowed Volume',
  deviation: 'Deviation',
  independentCost: 'Independent Cost',
  savingAllocation: 'Saving Allocation',
  actualAllocatedCost: 'Actual Allocated Cost',
  effectiveRate: 'Effective Rate',
  weightDiff: 'Weight Diff',
  volumeDiff: 'Volume Diff',
  chargeableDiff: 'Chargeable Weight Difference',
  dissolveReason: 'Dissolve Reason',
  reasonDetail: 'Detail Description',
  // entry/dialogs/AddMasterAirWaybillDialog fields
  actualFlightNo: 'Actual Flight No.',
  eta: 'ETA',
  bookedGrossWeight: 'Booked Gross Weight',
  // entry/dialogs/CreateProductOrderDialog fields
  selectAgreement: 'Select Agreement',
  // entry/components fields
  atd: 'ATD',
  ata: 'ATA',
  workDate: 'Work Date',
  remark: 'Remark',
  chargeableWeightTotalKg: 'Chargeable Weight Total (KG)',
  // entry/components/ChangeRequestDrawer fields
  changeField: 'Changed Field',
  originalValue: 'Original Value',
  newValue: 'New Value',
  changeReason: 'Change Reason',
  supplementaryNote: 'Supplementary Note',
  rejectReason: 'Reject Reason',
  // entry/components/CargoModeView fields
  baseRate: 'Base Rate',
  // entry/components/MasterOrderItem/HawbDetailDialog fields
  actualUldType: 'Actual ULD Type',
  actualShipper: 'Actual Shipper',
  actualConsignee: 'Actual Consignee',
  shipper: 'Shipper',
  consignee: 'Consignee',
  volumetricWeightLabel: 'Volumetric Weight',
  bubbleWeightShort: 'Bubble Weight',
  bubbleSaving: 'Bubble Saving',
  // entry/components/RightPanel fields
  weightRange: 'Weight Range',
  specialAttr: 'Special Attribute',
  // entry/components/PendingWarehouseZone fields
  bizOrderNoShort: 'Biz Order No.',
  bubbleBaseRate: 'Bubble Base Rate',
  // entry/components/CenterPanel/MasterOrderList + MasterOrderItem + ProductOrderPanel
  mawbList: 'MAWB List',
  hawbList: 'HAWB List',
  hawbListCount: 'HAWB List ({count})',
  costPricing: 'Cost & Pricing',
  trunkRateDefault: 'Trunk Rate (Default)',
  salesPriceTotal: 'Sales Price Total',
  mawbPayableTotal: 'Payable Total',
  // entry/components/CenterPanel/ProductOrderPanel/MonitorSection fields
  monitorMetrics: 'Information Summary',
  matchedBizCount: 'Matched Biz Orders',
  pendingWarehouse: 'Pending Warehouse',
  warehoused: 'Warehoused',
  changePending: 'Change Pending',
  // entry/components/RightPanel/MatchModeView fields
  remaining: 'Remaining',
  // cs-workbench/components/CenterPanel/BizOrderForm/ProfitDashboard fields
  costProfitDashboard: 'Cost & Profit Dashboard',
  receivableTotal: 'Receivable Total',
  salesBaseCostFormula: 'Sales Base Cost (Base Rate × Chargeable Weight)',
  // entry/components/CenterPanel/MasterOrderItem/MoInfoSection fields
  masterInfo: 'MAWB Info',
  actualTrunkRate: 'Airline Settlement Rate',
  bookedChargeableWeightLong: 'Booked Chargeable Weight',
  actualChargeableWeightLong: 'Actual Chargeable Weight',
  actualGrossWeight: 'Actual Gross Weight',
  // EQ cost calculation fields
  bookedVolume: 'Booked Volume',
  actualVolume: 'Actual Volume',
  standardChargeableWeight: 'Standard CW',
  airlineBilledCw: 'Airline Billed CW',
  airlineTotalCost: 'Airline Total Cost',
  eqAllocatedCost: 'EQ Allocated Cost',
  eqAllocatedCostBase: 'EQ Allocated Cost (Pool)',
  eqEffectiveRate: 'EQ Effective Cost Rate',
  trunkRateAverage: 'Trunk Rate (Avg)',
  grossWeightTotal: 'Actual Gross Weight (Total)',
  volumeTotal: 'Actual Volume (Total)',
  standardChargeableWeightTotal: 'Standard CW (Total)',
  trunkChargeableWeight: 'Trunk CW',
  customerCwShort: 'Customer CW',
  // Calculation formula tooltips (label hover)
  trunkChargeableWeightFormula: 'Trunk CW = Σ airline billed CW of all MAWBs',
  trunkRateAverageFormula: 'Avg trunk rate = trunk total cost ÷ trunk CW',
  trunkTotalCostFormula: 'Trunk total cost = Σ airline total cost of all MAWBs',
  eqAllocatedCostFormula: 'EQ allocated cost = pool total cost allocated by bubble-deviation kernel (independent cost − pool saving × |deviation| share; single member = pool total)',
  eqEffectiveRateFormula: 'EQ effective cost rate = EQ allocated cost ÷ standard CW (total)',
  grossWeightTotalFormula: 'Actual gross weight (total) = Σ actual gross weight of business orders (matched/warehoused/change-pending; booked value as fallback)',
  volumeTotalFormula: 'Actual volume (total) = Σ actual volume of business orders (matched/warehoused/change-pending; booked value as fallback)',
  standardCwTotalFormula: 'Standard CW (total) = round(Max(actual gross weight (total), actual volume (total) ÷ 0.006))',
  // entry/components/LeftPanel/ProductOrderCard fields
  mawbShort: 'MAWB',
  bizShort: 'Biz',
  hawbShort: 'HAWB',
  // cs-workbench/components/RightPanel/SmartAssistPanel fields
  customerProfile: 'Customer Profile',
  monthOrderCount: 'Monthly Orders',
  monthCargoVolume: 'Monthly Volume',
  monthSalesAmount: 'Monthly Sales',
  routeRecommendation: 'Route Recommendation',
  // entry/components/CenterPanel/MasterOrderItem/HawbCard fields
  bubbleCost: 'Bubble Cost',
  weightDiffShort: 'Wt Diff',
  // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection fields
  backfillBy: 'Backfill By',
  backfillAt: 'Backfill At',
}
